import type { ApiValue } from './properties';

export enum ScreenCategory {
  Auth = 'Auth',
  Onboarding = 'Onboarding',
  Home = 'Home',
  Volunteering = 'Volunteering',
  Rewards = 'Rewards',
  Challenges = 'Challenges',
  Profile = 'Profile'
}

export enum ScreenName {}
// Entries added here as individual mobile screens are instrumented

export interface BaseScreenProperties {
  [key: string]: ApiValue;
}

// Runtime lookup used by NativeAnalyticsClient to pass category to RudderStack
export const screenCategoryMap: Record<ScreenName, ScreenCategory> =
  {} as Record<ScreenName, ScreenCategory>;

// Maps each ScreenName to its allowed properties (extend per-screen as needed)
export type ScreenPropertiesMap = {
  [K in ScreenName]: BaseScreenProperties;
};
